/** Mirror of backend/src/utils/card-faces.ts. Only " // " with its spaces separates: "SP//dr" is one name. */
export function cardFaceNames(name: string): string[] {
  const text = String(name ?? '')
  // Inside brackets it is a pair of numbers: "Punch Card Token (1 // 2)".
  if (/\([^)]* \/\/ [^)]*\)/.test(text)) return [text]
  const [front, ...rest] = text.split(' // ')
  if (rest.length === 0) return [front]
  const tail = rest.join(' // ')
  const qualifier = tail.match(/\s*[([].*$/)?.[0] ?? ''
  return [`${front}${qualifier}`, `${tail.slice(0, tail.length - qualifier.length)}${qualifier}`]
}
